import { SALE_PERSON_URL } from "../../CONSTANTS";
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from "axios";
import Cookies from "universal-cookie";

const cook = new Cookies().get("loginData1");

const headersdata = {
  "content-type": "application/json",
  Accept: "application/json",
  Authorization: cook != undefined ? cook.accessToken : "",
  // 'Authorization': url.Auth_Token
};

export const addSalePerson = (data) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(SALE_PERSON_URL(), data, { headers: headersdata })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getItemList axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
export const editSalePerson = (id, data) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .put(SALE_PERSON_URL() + id, data, { headers: headersdata })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in editSalePerson axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
export const getSalePersonKeyValuePair = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(SALE_PERSON_URL() + "getKeyValueList", { headers: headersdata })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getItemDetail axios!");
        });
    } catch (error) {
      console.error("in LoginService > getItemDetail, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
export const getSalePersonDetailKeyValuePair = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(SALE_PERSON_URL() + "getKeyValueDetailsList", {
          headers: headersdata,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getItemDetail axios!");
        });
    } catch (error) {
      console.error("in LoginService > getItemDetail, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
